import { render, staticRenderFns } from "./ImpersonationError.vue?vue&type=template&id=5f00056e&scoped=true"
import script from "./ImpersonationError.vue?vue&type=script&lang=ts"
export * from "./ImpersonationError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f00056e",
  null
  
)

export default component.exports